import clsx from "clsx";
import React from "react";

type FormRadioInputProps = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "type" | "id"
> & {
    id: string;
    label: string;
};

const FormRadioInput = ({
    label,
    checked,
    id,
    className,
    ...props
}: FormRadioInputProps) => {
    return (
        <label htmlFor={id} className="flex items-center gap-3">
            <div className="relative">
                <input
                    id={id}
                    type="radio"
                    className={clsx("absolute inset-0 opacity-0", className)}
                    {...props}
                />
                <div className="w-5 h-5 rounded-full border border-surface-dark-1 text-surface-dark-1 flex items-center justify-center">
                    {checked && (
                        <div className="w-3 h-3 rounded-full bg-soft-green-80" />
                    )}
                </div>
            </div>
            <span className=" select-none">{label}</span>
        </label>
    );
};

export default FormRadioInput;
